class Privilegio {
    constructor(id, nome, descricao){
        this.id = id;
        this.nome = nome;
        this.descricao = descricao;
    }
}

export default Privilegio;
